import { render } from "./OrderDocumentModal.vue?vue&type=template&id=f6a5d56a&scoped=true"
import script from "./OrderDocumentModal.vue?vue&type=script&lang=js"
export * from "./OrderDocumentModal.vue?vue&type=script&lang=js"

import "./OrderDocumentModal.vue?vue&type=style&index=0&id=f6a5d56a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a5d56a"]])

export default __exports__